import React from 'react';

interface ContentWrapperProps {
  children: React.ReactNode;
}

const ContentWrapper: React.FC<ContentWrapperProps> = ({ children }) => (
  <div className="content-wrapper">
    <div className="container-fluid flex-grow-1 container-p-y">{children}</div>
  </div>
);

export default ContentWrapper;
